const prefix = '_company.'

const state = {
  selected: localStorage.getItem(prefix + 'id') || null,
  info: JSON.parse(localStorage.getItem(prefix + 'info')) || null
}

const mutations = {
  set (state, payload) {
    state.selected = payload.id
    state.info = payload

    localStorage.setItem(prefix + 'id', payload.id)
    localStorage.setItem(prefix + 'info', JSON.stringify(payload))
  },
  clean (state) {
    state.selected = null
    state.info = null

    localStorage.removeItem(prefix + 'id')
    localStorage.removeItem(prefix + 'info')
  }
}

const actions = {
  set ({ commit }, company) {
    commit('set', company)
  },
  clean ({ commit }) {
    commit('clean')
  }
}

const getters = {
  has (state) {
    return !!state.selected
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js